import { CommonModule } from '@angular/common'
import { Component } from '@angular/core'
import { FormsModule, ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms'
import { ButtonComponent, KENDO_BUTTONS } from '@progress/kendo-angular-buttons'
import { KENDO_DIALOGS } from '@progress/kendo-angular-dialog'
import { AddCommandDirective, CancelCommandDirective, CellTemplateDirective, ColumnComponent, CommandColumnComponent, DataBindingDirective, EditCommandDirective, EditTemplateDirective, FocusableDirective, GridComponent, GridToolbarFocusableDirective, KENDO_GRID, SaveCommandDirective, ToolbarTemplateDirective } from '@progress/kendo-angular-grid'
import { KENDO_INPUTS, TextBoxDirective } from '@progress/kendo-angular-inputs'
import { ClientServices } from '../../../../@theme/services/clients.service'
import { TypesServices } from '../../../../@theme/services/typeslist.service'
import { GridEditorBaseComponent } from '../../shared/rep-editor-base/grid-editor-base-component'
import { RepEditorStateService } from '../../shared/rep-editor-state.service'

@Component({
  selector: 'gd-type-editor-note-type',
  templateUrl: './type-editor-note-type.component.html',
  styleUrls: ['./type-editor-note-type.component.scss'],
  imports: [
    CommonModule,
    GridComponent,
    DataBindingDirective,
    ToolbarTemplateDirective,
    GridToolbarFocusableDirective,
    AddCommandDirective,
    ButtonComponent,
    ColumnComponent,
    EditTemplateDirective,
    TextBoxDirective,
    FormsModule,
    ReactiveFormsModule,
    CellTemplateDirective,
    CommandColumnComponent,
    FocusableDirective,
    EditCommandDirective,
    SaveCommandDirective,
    CancelCommandDirective,
    KENDO_GRID,
    KENDO_INPUTS,
    KENDO_DIALOGS,
    KENDO_BUTTONS,
  ]
})
export class TypeEditorNoteTypeComponent extends GridEditorBaseComponent {
  constructor(
    typesService: TypesServices,
    clientService: ClientServices,
    formBuilder: UntypedFormBuilder,
    repEditorStateService: RepEditorStateService,
  ) {
    super(typesService, clientService, formBuilder, repEditorStateService)
  }

  initGrid(): void {
    this.typesService.getNoteTypes().subscribe((response) => {
      this.repState.noteTypeList = response
    })
  }

  saveHandler({
    sender,
    rowIndex,
    formGroup,
    isNew,
  }: {
    sender: any
    rowIndex: any
    formGroup: any
    isNew: any
  }): void {
    const noteType = formGroup.value
    this.typesService.submitNoteTypeUpdate(noteType).subscribe(() => {
      sender.closeRow(rowIndex)
      this.initGrid()
    })
  }

  addHandler({ sender }: { sender: any }) {
    this.addHandlerShared(
      { sender },
      {
        noteTypeId: 0,
        noteTypeDescription: null,
        active: true,
      },
    )
  }

  removeHandler({ dataItem }: { dataItem: any }) {
    throw new Error('Method not implemented.')
  }

  createFormGroup(noteType: any): UntypedFormGroup {
    return this.formBuilder.group({
      noteTypeId: noteType.noteTypeId,
      noteTypeDescription: [noteType.noteTypeDescription, Validators.required],
      active: noteType.active,
    })
  }
}
